import axios from 'axios';
import { WORDPRESS_URL } from '@/constants';

export const fetchProspects = async (page: number = 1) => {
  try {
    const response = await axios.get(
      `https://strapi-33rd-team-nfl-draft.herokuapp.com/api/prospects?populate[0]=team&pagination[page]=${page}&pagination[pageSize]=1000`
    );
    return response.data;
  } catch (err) {
    console.error('Strapi players not available');
    return [];
  }
};
